import React, { useId } from 'react';
import PropTypes from 'prop-types';
import styles from './Textarea.module.scss';

/* Same labelling as Input: an id of its own when the caller passes
 * none, so the label is tied to the field, and the error / helper
 * text announced with it (QA CM-19). A caller's own id,
 * aria-invalid or aria-describedby still wins or is kept. */
const Textarea = ({
  label,
  error,
  helperText,
  id,
  className,
  ...rest
}) => {
  const autoId = useId();
  const textareaId = id || autoId;
  const messageId = error || helperText ? `${textareaId}-msg` : undefined;
  const describedBy =
    [rest['aria-describedby'], messageId].filter(Boolean).join(' ') || undefined;
  const wrapperClasses = [styles.wrapper, className || ''].filter(Boolean).join(' ');
  const textareaClasses = [styles.textarea, error ? styles.textareaError : '']
    .filter(Boolean)
    .join(' ');

  return (
    <div className={wrapperClasses}>
      {label && (
        <label htmlFor={textareaId} className={styles.label}>
          {label}
        </label>
      )}
      <textarea
        id={textareaId}
        className={textareaClasses}
        aria-invalid={error ? true : undefined}
        {...rest}
        aria-describedby={describedBy}
      />
      {error && <span id={messageId} className={styles.error}>{error}</span>}
      {!error && helperText && (
        <span id={messageId} className={styles.helperText}>{helperText}</span>
      )}
    </div>
  );
};

Textarea.propTypes = {
  label: PropTypes.string,
  error: PropTypes.string,
  helperText: PropTypes.string,
  id: PropTypes.string,
  className: PropTypes.string,
};

Textarea.defaultProps = {
  label: '',
  error: '',
  helperText: '',
  id: undefined,
  className: '',
};

export default Textarea;
